export const FOR_YOU_TEST_IDS = {
    FOR_YOU_MODAL: "for-you-modal",
    FOR_YOU_BANNER: "for-you-banner",
    FOR_YOU_BANNER_BUTTON: "for-you-banner-button",
    OPEN_FOR_YOU_MODAL_BUTTON: "open-for-you-modal-button",
    NEXT_STEP_BUTTON: "next-step-button",
    FINISH_AND_SEND_BUTTON: "finish-and-send-button",
    SAVE_BUTTON: "save-button",
    FINISH_BUTTON: "finish-button",
    CITY_SELECT_DROPDOWN: "city-select-dropdown",
    ROOMS_SELECT_BUTTON: "rooms-select-button",
    AREA_RANGE_LOWER: "area-range-lower",
    AREA_RANGE_UPPER: "area-range-upper",
    BUDGET_RANGE_UPPER: "budget-range-upper",
    NAME_FIELD: "name-field",
    EMAIL_FIELD: "email-field",
    PHONE_FIELD: "phone-field",
    MARKETING_CONSENT: "marketing-consent",
    MANAGE_YOUR_CRITERIA_BUTTON: "manage-your-criteria-button",
    ADDITIONAL_MESSAGE: "additional-message"
};
export const FOR_YOU_TEST_IDS = {
    FOR_YOU_MODAL: "for-you-modal",
    FOR_YOU_BANNER: "for-you-banner",
    FOR_YOU_BANNER_BUTTON: "for-you-banner-button",
    OPEN_FOR_YOU_MODAL_BUTTON: "open-for-you-modal-button",
    NEXT_STEP_BUTTON: "next-step-button",
    FINISH_AND_SEND_BUTTON: "finish-and-send-button",
    SAVE_BUTTON: "save-button",
    FINISH_BUTTON: "finish-button",
    CITY_SELECT_DROPDOWN: "city-select-dropdown",
    ROOMS_SELECT_BUTTON: "rooms-select-button",
    AREA_RANGE_LOWER: "area-range-lower",
    AREA_RANGE_UPPER: "area-range-upper",
    BUDGET_RANGE_UPPER: "budget-range-upper",
    NAME_FIELD: "name-field",
    EMAIL_FIELD: "email-field",
    PHONE_FIELD: "phone-field",
    MARKETING_CONSENT: "marketing-consent",
    MANAGE_YOUR_CRITERIA_BUTTON: "manage-your-criteria-button",
    ADDITIONAL_MESSAGE: "additional-message"
};
